//http://ostimar.pcgeek.cl:53380/lapi/public/api/

/*Servidor produccion*/
//http://192.168.1.150:81/lapi/public/api/
//http://164.77.147.234:81/lapi/public/api/

/*Servidor prueba*/
//http://192.168.1.150:81/backend/public/api/
//http://164.77.147.234:81/backend/public/api/

//http://homestead.test/api/
export var GLOBAL = {
	/*url que se conecta al homestead (backend local)*/
	//url: 'http://backend.test/api/'

	/*url para trabajar en desarrollo que se conecta a la bd ostimar-test del servidor (pruebas)*/
	//url:'http://186.67.63.71:81/backend/public/api/'

	/*url de ostimar server de prueba (productivo)*/
	//url: 'http://186.67.63.71:81/lapi/public/api/'

	//url:'http://192.168.1.200/lapibase/public/api/'

	/*servidor produccion con la que debe quedar para subirla al server*/
	url : 'https://apiostimar.avanze.cl/api/'

	/*servidor produccion backend*/
  	// url : 'http://192.168.208.162:81/backend/public/api/'

	/*servidor produccion desde fuera*/
	//url : 'http://186.67.63.71:81/lapi/public/api/'

	/**homestead fermin */
	// url : 'http://ostimar_backend.test/api/'
};

/*export var MENUS2 =[
	{"menus": [
		{
			"nombre":"Reportes",
			"ruta":"/reportes",
			"icono":"fas fa-file-alt",
			"tab":false,
			"menu":0,
			"posicion":1,
			"tipo":"navbar"
		},
		{
			"nombre":"Alertas",
			"ruta":"/alertas",
			"icono":"fas fa-bell",
			"tab":false,
			"menu":0,
			"posicion":2,
			"tipo":"navbar"
		}
	]},
	{"menus": [
		{
			"nombre":"Perfil",
			"ruta":"/perfil",
			"icono":"fas fa-user",
			"tab":false,
			"menu":1,
			"posicion":1,
			"tipo":"navbar"
		},
		{
			"nombre":"Permisos",
			"ruta":"/permisos",
			"icono":"fas fa-sitemap",
			"tab":false,
			"menu":1,
			"posicion":2,
			"tipo":"navbar"
		},
		{
			"nombre":"Login",
			"ruta":"/signup",
			"icono":"fas fa-key",
			"tab":false,
			"menu":1,
			"posicion":3,
			"tipo":"navbar"
		}
	]}
]*/

/**
 * posicion -> indica que menu se abre y se cierra.El numero debe coincidir con la posicion del menu en el arreglo.
 * icono -> nombre icono de font awesome
 * cerrado -> true: el submenu permanece oculto; false: el submenu se muestra al usuario.
 * Submenu:
 * 					nombre: Nombre que se ve en la columna y en el tab.
 * 					ruta: Ruta interna de angular para cargar el componente respectivo.
 * 					tab: true: desaparece menu de la columna derecha; false: aparece menu en la columna.
 * 					posicion: indica que menu se abre y se cierra.El numero debe coincidir con la posicion del menu en el arreglo.
 * 					menu: indice que ubica desde donde desaparece y aparece el menu en la columna.
 *
 */

 // export var MENUS = [
 // 	{"nombre":"Producción",
 // 	"posicion":1,
 // 	"icono":"fas fa-code-branch",
 // 	"cerrado":true,
 // 	"submenu": [
	// 	{"nombre": "Orden de Producción","ruta":"/orden","tab":false,"posicion":1,"menu":1},
 // 		{"nombre": "Impresión Etiquetas QR","ruta":"/ingreso","tab":false,"posicion":2,"menu":1},
 // 		{"nombre": "Historial Etiquetas QR","ruta":"/etiquetas","tab":false,"posicion":3,"menu":1},
	// 	{"nombre": "Empaque","ruta":"/empaque","tab":false,"posicion":4,"menu":1},
 // 		{"nombre": "Empaque -> Camara","ruta":"/empaquecamara","tab":false,"posicion":5,"menu":1}
 // 	]},
 // 	{"nombre":"Control Calidad",
 // 	"posicion":2,
 // 	"icono":"fas fa-thermometer-three-quarters",
 // 	"cerrado":true,
 // 	"submenu": []},
 // 	{"nombre":"Almacenamiento",
 // 	"posicion":3,
 // 	"icono":"fas fa-archive",
 // 	"cerrado":true,
 // 	"submenu": [
 // 		{"nombre": "Stock","ruta":"/stock","tab":false,"posicion":1,"menu":3},
 // 		{"nombre": "Pallets","ruta":"/pallets","tab":false,"posicion":2,"menu":3},
 // 		{"nombre": "Inventarios","ruta":"/inventarios","tab":false,"posicion":3,"menu":3},
 // 		{"nombre": "Camara","ruta":"/movimientos","tab":false,"posicion":4,"menu":3}
 // 	]},
 // 	{"nombre":"Personal",
 // 	"posicion":4,
 // 	"icono":"fas fa-users",
 // 	"cerrado":true,
 // 	"submenu": []},
 // 	{"nombre":"Comercial",
 // 	"posicion":5,
 // 	"icono":"fas fa-ship",
 // 	"cerrado":true,
 // 	"submenu": []},
 // 	{"nombre":"Consultas",
 // 	"posicion":6,
 // 	"icono":"far fa-newspaper",
 // 	"cerrado":true,
 // 	"submenu": [
	// 	{"nombre": "Entradas","ruta":"/stockentradas","tab":false,"posicion":1,"menu":6},
	// 	{"nombre": "Salidas","ruta":"/stocksalidas","tab":false,"posicion":2,"menu":6},
 // 		{"nombre": "Stock","ruta":"/stock","tab":false,"posicion":3,"menu":6}
 // 	]}
 // ]

export var MENUS = [
	{"nombre":"Producción",
	"posicion":1,
	"icono":"fas fa-code-branch",
	"cerrado":true,
	"submenu": [
		{"nombre": "Aduana","ruta":"/aduana","tab":false,"posicion":1,"menu":1},
		{"nombre": "Historial Etiquetas QR","ruta":"/etiquetas","tab":false,"posicion":2,"menu":1},
		{"nombre": "Impresión Etiquetas QR","ruta":"/ingreso","tab":false,"posicion":3,"menu":1},
		{"nombre": "Orden de Producción","ruta":"/orden","tab":false,"posicion":4,"menu":1},
		{"nombre": "Packing de Entrada","ruta":"/packingentrada","tab":false,"posicion":5,"menu":1},
		{"nombre": "Unión de Saldo", "ruta": "/unionsaldo", "tab": false, "posicion":6, "menu":1},
		/*{"nombre": "Reimprimir Etiqueta", "ruta": "/reimprimir", "tab": false, "posicion":7, "menu":1},*/
		{"nombre": "Reimprimir Pallet", "ruta": "/reimprimirpallet", "tab": false, "posicion":7, "menu":1}


		/*{"nombre": "Reimprimir Etiqueta", "ruta": "/reimprimir", "tab": false, "posicion":7, "menu":1}*/
	]},
	{"nombre":"Control Calidad",
	"posicion":2,
	"icono":"fas fa-thermometer-three-quarters",
	"cerrado":true,
	"submenu": [
		/*{"nombre": "Bloqueos","ruta":"/bloqueos","tab":false,"posicion":1,"menu":2},
		{"nombre": "Especificaciones de Proceso","ruta":"/especificaciones","tab":false,"posicion":2,"menu":2},*/
		{"nombre": "Lotes","ruta":"/lotes","tab":false,"posicion":1,"menu":2},
		/*{"nombre": "Packing List","ruta":"/packinglist","tab":false,"posicion":4,"menu":2},*/
		{"nombre": "Productos","ruta":"/productos","tab":false,"posicion":2,"menu":2},
		/*{"nombre": "Vencimientos","ruta":"/vencimientos","tab":false,"posicion":6,"menu":2}*/
		{"nombre": "Rendimiento", "ruta":"/rendimiento","tab":false,"posicion":3,"menu":2},
	]},
	{"nombre":"Almacenamiento",
	"posicion":3,
	"icono":"fas fa-archive",
	"cerrado":true,
	"submenu": [
		{"nombre": "Camara","ruta":"/movimientos","tab":false,"posicion":1,"menu":3},
		/*{"nombre": "Capacidad","ruta":"/capacidad","tab":false,"posicion":2,"menu":3},*/
		{"nombre": "Devolución", "ruta": "/devolucion", "tab": false, "posicion":2, "menu":3},
		{"nombre": "Pallets","ruta":"/pallets","tab":false,"posicion":3,"menu":3},
		{"nombre": "Solicitud de Movimiento","ruta":"/solicitud","tab":false,"posicion":4,"menu":3},
		{"nombre": "Solicitudes Aprobadas","ruta":"/solicitudesaprobadas","tab":false,"posicion":5,"menu":3},
		{"nombre": "Solicitudes En Revisión","ruta":"/solicitudenrevision","tab":false,"posicion":6,"menu":3},
		{"nombre": "Stock","ruta":"/stock","tab":false,"posicion":7,"menu":3}

		/*{"nombre": "Stock Historico","ruta":"/stockhistorico","tab":false,"posicion":5,"menu":3},*/
	]},
	{"nombre":"Personal",
	"posicion":4,
	"icono":"fas fa-users",
	"cerrado":true,
	"submenu": [
		/*{"nombre": "Desconche","ruta":"/desconche","tab":false,"posicion":1,"menu":4},
		{"nombre": "Fichas","ruta":"/fichas","tab":false,"posicion":2,"menu":4},
		{"nombre": "Tratos","ruta":"/tratos","tab":false,"posicion":3,"menu":4},
		{"nombre": "Estadística","ruta":"/estadistica","tab":false,"posicion":4,"menu":4}*/
	]},
	{"nombre":"Comercial",
	"posicion":5,
	"icono":"fas fa-ship",
	"cerrado":true,
	"submenu": [
		{"nombre": "Clientes","ruta":"/clientes","tab":false,"posicion":1,"menu":5},
		{"nombre": "Proveedores","ruta":"/proveedores","tab":false,"posicion":2,"menu":5},
		/*{"nombre": "Despachos","ruta":"/despachos","tab":false,"posicion":3,"menu":5},*/
	]},
	{"nombre":"Consultas",
	"posicion":6,
	"icono":"far fa-newspaper",
	"cerrado":true,
	"submenu": [
		{"nombre": "Entradas","ruta":"/stockentradas","tab":false,"posicion":1,"menu":6},
		{"nombre": "Salidas","ruta":"/stocksalidas","tab":false,"posicion":2,"menu":6}
		// {"nombre": "Stock","ruta":"/stock","tab":false,"posicion":3,"menu":6}
	]},
	{
		"nombre":"Stock",
		"posicion":7,
		"icono":"fas fa-th-large",
		"cerrado":true,
		"submenu":[
				{"nombre": "Stock Disponible","ruta":"/stock","tab":false,"posicion":1,"menu":7},
				{"nombre": "Stock Real","ruta":"/stockreal","tab":false,"posicion":2,"menu":7},
				{"nombre": "Stock Comercial","ruta":"/stockcomercial","tab":false,"posicion":3,"menu":7}
	 ]}
]

// export var MENUS = [
// 	{"nombre":"Consultas",
// 	"posicion":1,
// 	"icono":"far fa-newspaper",
// 	"cerrado":true,
// 	"submenu": [
// 		{"nombre": "Entradas","ruta":"/stockentradas","tab":false,"posicion":1,"menu":1},
// 		{"nombre": "Salidas","ruta":"/stocksalidas","tab":false,"posicion":2,"menu":1},
// 		{"nombre": "Stock","ruta":"/stock","tab":false,"posicion":3,"menu":1}
// 	]}
// ]



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/global.ts